var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1_Landing-page",
    transform: "translate(-955, -6049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn",
    transform: "translate(955, 6049)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#BFE82D",
    strokeWidth: 2,
    fill: "#BFE82D",
    x: 1,
    y: 1,
    width: 58,
    height: 58,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "ic_go-to-popup",
    transform: "translate(31.8913, 30.8913) scale(1, -1) rotate(45) translate(-31.8913, -30.8913)translate(17.7976, 20.39)",
    fill: "#040802",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7264859,0.339661469 C17.3171834,-0.163834753 18.2054408,-0.0954395501 18.6852914,0.464414173 L27.7759888,9.51049988 C28.3245419,10.0596196 28.3245794,10.9457799 27.7760654,11.4947405 L18.7118571,20.5122411 C18.6647103,20.567116 18.6132129,20.61833 18.5578186,20.6655774 C17.9671304,21.1690658 17.0789829,21.1006762 16.5727566,20.5126006 C16.0652857,19.9230793 16.1343435,19.0350139 16.6981535,18.5565063 L23.342,11.9436194 L1.4090463,12.5264288 C0.677154565,12.5264288 0.0747896502,11.9698989 0.00645568699,11.2572122 L-1.0965876e-13,11.1218513 C-1.0965876e-13,10.3455424 0.631413018,9.71719607 1.39579171,9.71737179 L23.408,9.13361942 L16.7268464,2.47513918 C16.699285,2.45169147 16.6726374,2.42715651 16.6469428,2.40159049 L16.5727566,2.32185543 C16.0652857,1.7323341 16.1343435,0.844268681 16.7264859,0.339661469 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactArrow);
export default __webpack_public_path__ + "static/media/contactArrow.10ed9314f8bfa150ddcdd57b0dff1fa4.svg";
export { ForwardRef as ReactComponent };